import { useCallback, useState } from 'react'

export default () => {
  const [showFeedBack, setShowFeedBack] = useState(false)
  const [feedBackProp, setFeedBackProp] = useState<any>()

  return {
    showFeedBack,
    setShowFeedBack,
    feedBackProp,
    setFeedBackProp
  }
}
